import type {
  GetAkelaMeritBadgesLookupResponse,
  GetAwardsResponse,
  GetMeritBadgesQueryParams,
  GetMeritBadgesResponse,
} from '@appTypes/esb';
import { tagTypes } from '@modules/rtk/constants';
import { esbApi } from '@modules/rtk/esb-api';

const ONE_DAY = 60 * 60 * 24;

export const dictApi = esbApi.injectEndpoints({
  endpoints: builder => ({
    /**
     * @esbEndpoint GET /advancements/awards
     */
    getDictAwards: builder.query<GetAwardsResponse, void>({
      query: () => ({
        url: '/advancements/awards',
      }),
      keepUnusedDataFor: ONE_DAY,
      providesTags: [tagTypes.Awards],
    }),
    /**
     * @esbEndpoint GET /advancements/v2/meritBadges
     */
    getDictMeritBadges: builder.query<
      GetMeritBadgesResponse,
      { params?: GetMeritBadgesQueryParams }
    >({
      query: arg => ({
        url: '/advancements/v2/meritBadges',
        params: arg.params,
      }),
      keepUnusedDataFor: ONE_DAY,
      providesTags: [tagTypes.MeritBadges],
    }),
    /**
     * @esbEndpoint GET /lookups/advancements/akelaMeritBadges
     */
    getDictAkelaMeritBadges: builder.query<
      GetAkelaMeritBadgesLookupResponse,
      void
    >({
      query: () => ({
        url: 'lookups/advancements/akelaMeritBadges',
      }),
      keepUnusedDataFor: ONE_DAY,
      providesTags: [tagTypes.AkelaMeritBadges],
    }),
  }),
});

export const {
  useGetDictAwardsQuery,
  useLazyGetDictAwardsQuery,
  useGetDictMeritBadgesQuery,
  useLazyGetDictMeritBadgesQuery,
  useGetDictAkelaMeritBadgesQuery,
} = dictApi;
